import React from 'react';
import Colab from './Colab';

function Create() {
  return (
    <div name="create" className="create">
      <div className="big-text assistant">
        If you can dream it,
        <br />
        we can build it.
      </div>
      <div className="small-text abel">
        At Shipyard Studio our goal is to work with creators to bring NFT collections to life. We
        will work closely with you to create dynamic and efficient smart contracts that allow you to
        control every part of your NFT collection.
      </div>
      <Colab />
    </div>
  );
}

export default Create;
